import axios from 'axios'
import {
  RECEIPT_SPEND_REQUEST,
  RECEIPT_SPEND_SUCCESS,
  RECEIPT_SPEND_FAILURE,
  META_RECEIPT_SPEND_REQUEST,
  META_RECEIPT_SPEND_SUCCESS,
  META_RECEIPT_SPEND_FAILURE,
  OWNER_DAILY_COUNT_REQUEST,
  OWNER_DAILY_COUNT_SUCCESS,
  OWNER_DAILY_COUNT_FAIL
  // AI_RECEIPT_SPEND_REQUEST,
  // AI_RECEIPT_SPEND_SUCCESS,
  // AI_RECEIPT_SPEND_FAILURE
} from '../constants/metaConstants.js'

import { API_URL } from '../apiUrl.js'
import { authHeader } from '../utils/authHeader.js'

export const getReceiptSpendTotal = (id) => async (dispatch, getState) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: RECEIPT_SPEND_REQUEST })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = {
      headers: authHeader(userInfo)
    }

    const { data } = await axios.get(`${API_URL}/meta/allmeta/${id}`, config)

    dispatch({
      type: RECEIPT_SPEND_SUCCESS,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: RECEIPT_SPEND_FAILURE,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
    })
  }
}

/**
 * Fetches the daily totals of receipts.
 * Dispatches actions to indicate the request, success, or failure of the operation.
 */
export const getDailyTotals = (id) => async (dispatch, getState) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: META_RECEIPT_SPEND_REQUEST })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = {
      headers: authHeader(userInfo)
    }

    const { data } = await axios.get(`${API_URL}/meta/totaldata/${id}`, config)

    dispatch({ type: META_RECEIPT_SPEND_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: META_RECEIPT_SPEND_FAILURE,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
    console.error('Error:', err)
  }
}

export const getDailyTotalsByOwner = (cid) => async (dispatch, getState) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: OWNER_DAILY_COUNT_REQUEST })

    const {
      ownerLogin: { ownerInfo }
    } = getState()

    const config = {
      headers: authHeader(ownerInfo)
    }

    const { data } = await axios.get(
      `${API_URL}/meta/ownerreceipt/${cid}`,
      config
    )

    dispatch({ type: OWNER_DAILY_COUNT_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: OWNER_DAILY_COUNT_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
    console.error('Error:', err)
  }
}

// export const getaiDailyTotals = () => async (dispatch) => {
//   try {
//     dispatch({ type: AI_RECEIPT_SPEND_REQUEST })
//
//     const config = {
//       headers: {
//         'Content-Type': 'application/json'
//       }
//     }
//
//     const { data } = await axios.get(`${API_URL}/meta/aimetadata`, config)
//     dispatch({ type: AI_RECEIPT_SPEND_SUCCESS, payload: data })
//   } catch (err) {
//     dispatch({
//       type: AI_RECEIPT_SPEND_FAILURE,
//       payload:
//         err.response && err.response.data.message
//           ? err.response.data.message
//           : err.message
//     })
//     console.error('Error:', err)
//   }
// }
